import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import MovementForm from "@/components/MovementForm";

export default function MovementDialog({ open, onOpenChange, initial = null }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="movement-dialog">
        <DialogHeader>
          <DialogTitle>{initial ? "Editar movimiento" : "Registro rápido"}</DialogTitle>
          <DialogDescription>{initial ? "Corrige monto, categoría, cuenta u otros datos del movimiento." : "Captura un By o To. Puedes leer el ticket con IA."}</DialogDescription>
        </DialogHeader>
        <MovementForm initial={initial} onSaved={() => onOpenChange(false)} embedded />
      </DialogContent>
    </Dialog>
  );
}
